import React, {useEffect, useState} from 'react';
import {TextField} from '../../libs/react-components-admin/fields/text-like-field';
import ColorField from '../../libs/react-components-admin/fields/color-field';
import PaddingConfig from './padding-config';

const fontStyles = [
  {label: '', value: 'DEFAULT'},
  {label: 'Bold', value: 'BOLD'},
  {label: 'Italic', value: 'ITALIC'},
  {label: 'Bold Italic', value: 'BOLD_ITALIC'},
];

const ButtonConfig = ({idPrefix, value, onChange}) => {

  const [model, setModel] = useState(value || {});

  useEffect(() => { onChange(model); }, [model]);

  return <>
    <TextField id={idPrefix + 'ButtonLabel'}
               label="Label"
               value={model.label}
               onChange={v => setModel({...model, label: v})}/>
    <div className="row">
      <div className="col-12 col-md-4">
        <div className="mb-3">
          <label htmlFor={idPrefix + 'ButtonFontStyle'} className="form-label">Text style</label>
          <select id={idPrefix + 'ButtonFontStyle'}
                  className="form-select input-sm"
                  value={model.fontStyle}
                  onChange={e => setModel({...model, fontStyle: e.target.value})}>
            {fontStyles.map(fontStyle => <option key={fontStyle.value}
                                                 value={fontStyle.value}>{fontStyle.label}</option>)}
          </select>
        </div>
      </div>
      <div className="col-12 col-md-4">
        <ColorField id={idPrefix + 'ButtonFontColor'}
                    label="Text color"
                    value={model.fontColor || ''}
                    onChange={v => setModel({...model, fontColor: v})}/>
      </div>
      <div className="col-12 col-md-4">
        <div className="mb-3">
          <label htmlFor={idPrefix + 'ButtonFontSize'} className="form-label">Text size in pixels</label>
          <input id={idPrefix + 'ButtonFontSize'}
                 type="number" min="1" step="1"
                 className="form-control input-sm"
                 value={model.fontSizeInPx || ''}
                 onChange={e => setModel({...model, fontSizeInPx: e.target.value})}/>
        </div>
      </div>
      <div className="col-12 col-md-4">
        <ColorField id={idPrefix + 'ButtonBgColor'}
                    label="Background color"
                    colorOnChoose="#0000ff"
                    value={model.bgColor || ''}
                    onChange={v => setModel({...model, bgColor: v})}/>
      </div>
      <div className="col-12">
        <PaddingConfig value={model.padding}
                       onChange={v => setModel({...model, padding: v})}/>
      </div>
    </div>
  </>;
};

const buttonWidths = [
  {label: '', value: ''},
  {label: '100%', value: '100'},
  {label: '83.33%', value: '83.33'},
  {label: '66.66%', value: '66.66'},
  {label: '50%', value: '50'},
  {label: '33.33%', value: '33.33'},
  {label: '16.66%', value: '16.66'},
];
export {buttonWidths};

const RowWithButtonConfig = ({idPrefix, value, onChange}) => {

  const [model, setModel] = useState(value || {});

  useEffect(() => { onChange(model); }, [model]);

  return <>
    <div className="mb-2 text-muted">
      <span className="material-icons align-bottom text-info">info</span> Leave blank to use your theme defaults
    </div>
    <ButtonConfig idPrefix={idPrefix}
                  value={model}
                  onChange={v => setModel({...model, ...v})}/>
    <div className="row">
      <div className="col-12">
        <div className="mb-3">
          <label htmlFor={idPrefix + 'ButtonWidth'} className="form-label">Width</label>
          <select id={idPrefix + 'ButtonWidth'}
                  className="form-select input-sm"
                  value={model.widthInPercent || ''}
                  onChange={e => setModel({...model, widthInPercent: e.target.value})}>
            {buttonWidths.map(width =>
              <option key={width.value} value={width.value}>{width.label}</option>
            )}
          </select>
        </div>
      </div>
    </div>
  </>
};

export {RowWithButtonConfig};